import { z } from "zod";
import { historicalCatalogueReferenceSchema } from "./catalogue-management.js";

export const skillStatusSchema = z.enum(["unassessed", "to_train", "on_checklist", "established"]);
export const evidenceSourceSchema = z.enum(["assessment", "test", "supervisor", "seed"]);

export const employeeSkillProgressSchema = z.object({
  employeeId: z.string().min(1),
  skillId: z.string().min(1),
  status: skillStatusSchema,
  trainingStarted: z.boolean(),
  trainingCompleted: z.boolean(),
  assessmentAttempts: z.number().int().nonnegative(),
  testAttempts: z.number().int().nonnegative(),
  evidenceSource: evidenceSourceSchema.nullable(),
  submittedAt: z.string().datetime().nullable(),
  supervisorFeedback: z.string().nullable(),
  catalogue: historicalCatalogueReferenceSchema.optional(),
});

export const actionCountersSchema = z.object({
  assessmentStarts: z.number().int().nonnegative(),
  assessmentCompletions: z.number().int().nonnegative(),
  assessmentPasses: z.number().int().nonnegative(),
  assessmentFailures: z.number().int().nonnegative(),
  trainingStarts: z.number().int().nonnegative(),
  trainingCompletions: z.number().int().nonnegative(),
  testAttempts: z.number().int().nonnegative(),
  testPasses: z.number().int().nonnegative(),
  testFailures: z.number().int().nonnegative(),
  checklistSubmissions: z.number().int().nonnegative(),
  supervisorConfirms: z.number().int().nonnegative(),
  supervisorKeeps: z.number().int().nonnegative(),
  supervisorDenials: z.number().int().nonnegative(),
});

export const activityEventSchema = z.object({
  id: z.string().min(1),
  type: z.string().min(1),
  actorId: z.string().min(1),
  employeeId: z.string().min(1),
  skillId: z.string().nullable(),
  timestamp: z.string().datetime(),
  resultingStatus: skillStatusSchema.nullable(),
  feedback: z.string().nullable(),
  summary: z.string().min(1),
  catalogue: historicalCatalogueReferenceSchema.optional(),
});

export type SkillStatus = z.infer<typeof skillStatusSchema>;
export type EmployeeSkillProgress = z.infer<typeof employeeSkillProgressSchema>;
export type ActionCounters = z.infer<typeof actionCountersSchema>;
export type ActivityEvent = z.infer<typeof activityEventSchema>;
